module.exports = __webpack_public_path__ + "img/default-verifyCode.1d083db8.png";